// extracted by css-extract-rspack-plugin
export default {"title":"_9a2b0862"};